import { AUDIT_RUBRICS } from '@/client/services/sessionAudit/internal'

import {
  COACH_ESCALATION_SLUG,
  EXPERIENCED_AUDIT_LEVELS,
  INTERNAL_COMMENT_SLUG,
  LATEST_AUDIT_RUBRIC_VERSION,
  SAFETY_REPORT_SLUG,
} from './constants'
import type {
  AuditRubricQuestion,
  AuditRubricQuestions,
  AuditRubricVersion,
  TutorAuditorLevel,
} from './types'

export function isExperiencedAuditLevel(auditLevel: TutorAuditorLevel | null): boolean {
  return auditLevel != null && EXPERIENCED_AUDIT_LEVELS.includes(auditLevel)
}

export function getAuditRubric(auditVersion?: AuditRubricVersion): AuditRubricQuestions {
  return AUDIT_RUBRICS[auditVersion ?? LATEST_AUDIT_RUBRIC_VERSION]
}

export function isSensitiveAuditRubricQuestion(question: AuditRubricQuestion): boolean {
  return [INTERNAL_COMMENT_SLUG, SAFETY_REPORT_SLUG, COACH_ESCALATION_SLUG].includes(question.slug)
}
